import React from 'react';
import { connect } from 'react-redux';
import { signupPlus, signupSubtract } from '../../../Redux/Actions/SignupWizardActions';
import StandardWizardNav from './StandardAccount/Nav/StandardWizardNav';
import Membership from '../Pages/EndUser/Signup/Membership/Membership';
import InterestSignup from '../Pages/EndUser/Signup/Interests/InterestSignup';
import Addons from '../Pages/EndUser/Signup/Addons/Addons';
import Confirmation from '../Pages/EndUser/Signup/Confirmation/Confirmation';

// import './signupWizard.scss';
import './SignupWizardLayout.scss';

class SignupWizardLayout extends React.Component {
    constructor(props) {
        super(props);
        this.wizardPages = this.wizardPages.bind(this);
    }

    wizardPages(step) {
        switch (step) {
            case 1:
                return (
                    <Membership />                    
                );
            case 2:
                return (
                    <InterestSignup
                        nextStep={() => this.props.signupPlus(this.props.signupWizard.signupStep)}
                        previousStep={() => {
                            this.props.signupSubtract(this.props.signupWizard.signupStep)
                        }}
                    />
                );
            case 3:
                return (
                    <Addons
                        nextStep={() => this.props.signupPlus(this.props.signupWizard.signupStep)}
                        previousStep={() => {
                            this.props.signupSubtract(this.props.signupWizard.signupStep)
                        }}
                    />
                );
            case 4:
                return (
                    <Confirmation previousStep={() => {
                        this.props.signupSubtract(this.props.signupWizard.signupStep)
                        }}
                    />
                );
            default:
                return "Error";
        }
    }

    render() {
        return (
            <div className="" >
                <StandardWizardNav />
                <div className="row membershipPage">
                    <div id="signupForm" className="">
                        {this.wizardPages(this.props.signupWizard.signupStep)}
                    </div>
                    {/* <div className="col-lg-5">
                    {(this.props.membership.selectedMembershipType && this.props.membership.selectedMembershipType.description !== '') ? 
                    <div className="cowBackground"></div> : null }
                    </div> */}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        signupWizard: state.signupWizard,
        membership: state.membership
    }
}

export default connect(mapStateToProps, { signupPlus, signupSubtract })(SignupWizardLayout);